import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../auth';
import { loadSolveEvents } from '../../../utils/firebase';
import { deriveCaseStats, deriveGlobalStats } from '../../../utils/statsUtils';
import { PRACTICE_MODES } from '../../../constants/modes';
import StatPanel from '../panels/StatPanel';

const getGlobalTitle = (mode) => {
  switch (mode) {
    case PRACTICE_MODES.OLL.EXECUTION:
      return "Global OLL Execution Stats";
    case PRACTICE_MODES.OLL.RECOGNITION:
      return "Global OLL Recognition Stats";
    case PRACTICE_MODES.PLL.EXECUTION:
      return "Global PLL Execution Stats";
    case PRACTICE_MODES.PLL.RECOGNITION:
      return "Global PLL Recognition Stats";
    default:
      return "Global Stats";
  }
};

const StatsContainer = ({ algorithmId, mode, newTime }) => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;

    const fetchStats = async () => {
      if (!algorithmId || !mode || !user) return;

      try {
        const events = await loadSolveEvents();
        if (ignore) return;
        setStats({
          algorithm: deriveCaseStats(events, algorithmId, mode),
          global: deriveGlobalStats(events, mode),
        });
        setError(null);
      } catch (err) {
        if (ignore) return;
        console.error('Error fetching stats:', err);
        setError('Failed to load statistics');
      }
    };

    fetchStats();
    return () => {
      ignore = true;
    };
  }, [algorithmId, mode, user, newTime]);

  if (!algorithmId) return null;
  if (error) return <div className="error-message">{error}</div>;
  if (!stats) return <div>Loading stats...</div>;

  return (
    <div className="stats-container">
      <StatPanel title="Algorithm Stats" stats={stats.algorithm} />
      <StatPanel title={getGlobalTitle(mode)} stats={stats.global} />
    </div>
  );
};

export default StatsContainer; 